import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RankingsListComponent } from './rankings-list/rankings-list.component';
import { RankingsCreateComponent } from './rankings-create/rankings-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: RankingsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: RankingsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'rankings-create/:id',
        component: RankingsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RankingsRoutingModule { }
